import React from 'react';
import Slider from 'react-slick'; // Import React Slick
import 'slick-carousel/slick/slick.css'; // Slick core CSS
import 'slick-carousel/slick/slick-theme.css'; // Slick theme CSS
import './Cars.css'; // Custom styles

// Import images
import xuv500Image1 from '../assets/images/mahindra-xuv500-1.jpeg.jpeg';
import xuv500Image2 from '../assets/images/mahindra-xuv500-2.jpeg.jpg';
import xuv500Image3 from '../assets/images/mahindra-xuv500-3.jpeg.jpg';

import bmwImage1 from '../assets/images/bmw-530d-1.jpeg.jpeg';
import bmwImage2 from '../assets/images/bmw-530d-2.jpeg.jpg';
import bmwImage3 from '../assets/images/bmw-530d-3.jpeg.jpg';

import HondaImage1 from '../assets/images/Honda-1.jpeg.jpg';
import HondaImage2 from '../assets/images/Honda-2.jpeg.jpg';
import HondaImage3 from '../assets/images/Honda-3.jpeg.jpg';

import ToyotoImage1 from '../assets/images/Toyoto-1.jpeg.jpg';
import ToyotoImage2 from '../assets/images/Toyoto-2.jpeg.jpg';
import ToyotoImage3 from '../assets/images/Toyoto-3.jpeg.jpg';

import FordImage1 from '../assets/images/Ford-1.jpeg.jpg';
import FordImage2 from '../assets/images/Ford-2.jpeg.jpg';
import FordImage3 from '../assets/images/Ford-3.jpeg.jpg';

import JAGUARImage1 from '../assets/images/JAGUAR-1.jpeg.jpg';
import JAGUARImage2 from '../assets/images/JAGUAR-2.jpeg.jpg';
import JAGUARImage3 from '../assets/images/JAGUAR-3.jpeg.jpg';

import HyndaiImage1 from '../assets/images/Hyndai-1.jpeg.jpg';
import HyndaiImage2 from '../assets/images/Hyndai-2.jpeg.jpg';
import HyndaiImage3 from '../assets/images/Hyndai-3.jpeg.jpg';

import MaruthiImage1 from '../assets/images/Maruthi-1.jpeg.jpg';
import MaruthiImage2 from '../assets/images/Maruthi-2.jpeg.jpg';
import MaruthiImage3 from '../assets/images/Maruthi-3.jpeg.jpg';

import ToyotofImage1 from '../assets/images/Toyotof-1.jpeg.jpg';
import ToyotofImage2 from '../assets/images/Toyotof-2.jpeg.jpg';
import ToyotofImage3 from '../assets/images/Toyotof-3.jpeg.jpg';

import MaruthizImage1 from '../assets/images/Maruthiz-1.jpeg.jpg';
import MaruthizImage2 from '../assets/images/Maruthiz-2.jpeg.jpg';
import MaruthizImage3 from '../assets/images/Maruthiz-3.jpeg.jpg';

import MGImage1 from '../assets/images/MG-1.jpeg.jpg';
import MGImage2 from '../assets/images/MG-2.jpeg.jpg';
import MGImage3 from '../assets/images/MG-3.jpeg.jpg';

import HyundaiiImage1 from '../assets/images/Hyndaii-1.jpeg.jpg';
import HyundaiiImage2 from '../assets/images/Hyndaii-2.jpeg.jpg';
import HyundaiiImage3 from '../assets/images/Hyndaii-3.jpeg.jpg';

import ChevroletImage1 from '../assets/images/Chevrolet-1.jpeg.jpg';
import ChevroletImage2 from '../assets/images/Chevrolet-2.jpeg.jpg';
import ChevroletImage3 from '../assets/images/Chevrolet-3.jpeg.jpg';

import FortunerImage1 from '../assets/images/Fortuner-1.jpeg.jpg';
import FortunerImage2 from '../assets/images/Fortuner-2.jpeg.jpg';
import FortunerImage3 from '../assets/images/Fortuner-3.jpeg.jpg';

import EliteImage1 from '../assets/images/Elite-1.jpeg.jpg';
import EliteImage2 from '../assets/images/Elite-2.jpeg.jpg';
import EliteImage3 from '../assets/images/Elite-3.jpeg.jpg';

import GetzImage1 from '../assets/images/Getz-1.jpeg.jpg';
import GetzImage2 from '../assets/images/Getz-2.jpeg.jpg';
import GetzImage3 from '../assets/images/Getz-3.jpeg.jpg';

import VernaiImage1 from '../assets/images/Vernai-1.jpeg.jpg';
import VernaiImage2 from '../assets/images/Vernai-2.jpeg.jpg';
import VernaiImage3 from '../assets/images/Vernai-3.jpeg.jpg';


import grandImage1 from '../assets/images/grand-1.jpeg.jpg';
import grandImage2 from '../assets/images/grand-2.jpeg.jpg';
import grandImage3 from '../assets/images/grand-3.jpeg.jpg';

import InnovaImage1 from '../assets/images/Innova-1.jpeg.jpg';
import InnovaImage2 from '../assets/images/Innova-2.jpeg.jpg';
import InnovaImage3 from '../assets/images/Innova-3.jpeg.jpg';

import AVEOImage1 from '../assets/images/AVEO-1.jpeg.jpg';
import AVEOImage2 from '../assets/images/AVEO-2.jpeg.jpg';
import AVEOImage3 from '../assets/images/AVEO-3.jpeg.jpg';

import MarazzoImage1 from '../assets/images/Marazzo-1.jpeg.jpg';
import MarazzoImage2 from '../assets/images/Marazzo-2.jpeg.jpg';
import MarazzoImage3 from '../assets/images/Marazzo-3.jpeg.jpg';

import suzukiImage1 from '../assets/images/suzuki-1.jpeg.jpg';
import suzukiImage2 from '../assets/images/suzuki-2.jpeg.jpg';
import suzukiImage3 from '../assets/images/suzuki-3.jpeg.jpg';

import ScorpioImage1 from '../assets/images/Scorpio-1.jpeg.jpg';
import ScorpioImage2 from '../assets/images/Scorpio-2.jpeg.jpg';
import ScorpioImage3 from '../assets/images/Scorpio-3.jpeg.jpg';

import FORDDImage1 from '../assets/images/FORDD-1.jpeg.jpg';
import FORDDImage2 from '../assets/images/FORDD-2.jpeg.jpg';
import FORDDImage3 from '../assets/images/FORDD-3.jpeg.jpg';

import DZIREImage1 from '../assets/images/DZIRE-1.jpeg.jpg';
import DZIREImage2 from '../assets/images/DZIRE-2.jpeg.jpg';
import DZIREImage3 from '../assets/images/DZIRE-3.jpeg.jpg';

import VENTOOImage1 from '../assets/images/VENTOO-1.jpeg.jpg';
import VENTOOImage2 from '../assets/images/VENTOO-2.jpeg.jpg';
import VENTOOImage3 from '../assets/images/VENTOO-3.jpeg.jpg';

import CrystaImage1 from '../assets/images/Crysta-1.jpeg.jpg';
import CrystaImage2 from '../assets/images/Crysta-2.jpeg.jpg';
import CrystaImage3 from '../assets/images/Crysta-3.jpeg.jpg';

import PoloImage1 from '../assets/images/Polo-1.jpeg.jpg';
import PoloImage2 from '../assets/images/Polo-2.jpeg.jpg';
import PoloImage3 from '../assets/images/Polo-3.jpeg.jpg';

import InnovaaaImage1 from '../assets/images/Innovaaa-1.jpeg.jpg';
import InnovaaaImage2 from '../assets/images/Innovaaa-2.jpeg.jpg';
import InnovaaaImage3 from '../assets/images/Innovaaa-3.jpeg.jpg';

import XUVImage1 from '../assets/images/XUV-1.jpeg.jpg';
import XUVImage2 from '../assets/images/XUV-2.jpeg.jpg';
import XUVImage3 from '../assets/images/XUV-3.jpeg.jpg';

import SX4Image1 from '../assets/images/SX4-1.jpeg.jpg';
import SX4Image2 from '../assets/images/SX4-2.jpeg.jpg';
import SX4Image3 from '../assets/images/SX4-3.jpeg.jpg';

import InnovaaImage1 from '../assets/images/Innovaa-1.jpeg.jpg';
import InnovaaImage2 from '../assets/images/Innovaa-2.jpeg.jpg';
import InnovaaImage3 from '../assets/images/Innovaa-3.jpeg.jpg';

import swifttImage1 from '../assets/images/swiftt-1.jpeg.jpg';
import swifttImage2 from '../assets/images/swiftt-2.jpeg.jpg';
import swifttImage3 from '../assets/images/swiftt-3.jpeg.jpg';

import XyloImage1 from '../assets/images/Xylo-1.jpeg.jpg';
import XyloImage2 from '../assets/images/Xylo-2.jpeg.jpg';
import XyloImage3 from '../assets/images/Xylo-3.jpeg.jpg';

import flueneceImage1 from '../assets/images/fluenece-1.jpeg.jpg';
import flueneceImage2 from '../assets/images/fluenece-2.jpeg.jpg';
import flueneceImage3 from '../assets/images/fluenece-3.jpeg.jpg';

import BalenoImage1 from '../assets/images/Baleno-1.jpeg.jpg';
import BalenoImage2 from '../assets/images/Baleno-2.jpeg.jpg';
import BalenoImage3 from '../assets/images/Baleno-3.jpeg.jpg';

import EcosportImage1 from '../assets/images/Ecosport-1.jpeg.jpg';
import EcosportImage2 from '../assets/images/Ecosport-2.jpeg.jpg';
import EcosportImage3 from '../assets/images/Ecosport-3.jpeg.jpg';

import santrooImage1 from '../assets/images/santroo-1.jpeg.jpg';
import santrooImage2 from '../assets/images/santroo-2.jpeg.jpg';
import santrooImage3 from '../assets/images/santroo-3.jpeg.jpg';

import crystImage1 from '../assets/images/cryst-1.jpeg.jpg';
import crystImage2 from '../assets/images/cryst-2.jpeg.jpg';
import crystImage3 from '../assets/images/cryst-3.jpeg.jpg';

import GXXImage1 from '../assets/images/GXX-1.jpeg.jpg';
import GXXImage2 from '../assets/images/GXX-2.jpeg.jpg';
import GXXImage3 from '../assets/images/GXX-3.jpeg.jpg';

import innovasImage1 from '../assets/images/innovas-1.jpeg.jpg';
import innovasImage2 from '../assets/images/innovas-2.jpeg.jpg';
import innovasImage3 from '../assets/images/innovas-3.jpeg.jpg';

import FortunerrImage1 from '../assets/images/Fortunerr-1.jpeg.jpg';
import FortunerrImage2 from '../assets/images/Fortunerr-2.jpeg.jpg';
import FortunerrImage3 from '../assets/images/Fortunerr-3.jpeg.jpg';

import BMWwImage1 from '../assets/images/BMWw-1.jpeg.jpg';
import BMWwImage2 from '../assets/images/BMWw-2.jpeg.jpg';
import BMWwImage3 from '../assets/images/BMWw-3.jpeg.jpg';

import brezzaImage1 from '../assets/images/brezza-1.jpeg.jpg';
import brezzaImage2 from '../assets/images/brezza-2.jpeg.jpg';
import brezzaImage3 from '../assets/images/brezza-3.jpeg.jpg';

import MaxindraaImage1 from '../assets/images/Maxindraa-1.jpeg.jpg';
import MaxindraaImage2 from '../assets/images/Maxindraa-2.jpeg.jpg';
import MaxindraaImage3 from '../assets/images/Maxindraa-3.jpeg.jpg';

import sonetImage1 from '../assets/images/sonet-1.jpeg.jpg';
import sonetImage2 from '../assets/images/sonet-2.jpeg.jpg';
import sonetImage3 from '../assets/images/sonet-3.jpeg.jpg';

import micraImage1 from '../assets/images/micra-1.jpeg.jpg';
import micraImage2 from '../assets/images/micra-2.jpeg.jpg';
import micraImage3 from '../assets/images/micra-3.jpeg.jpg';

import WAGONRImage1 from '../assets/images/WAGONR-1.jpeg.jpg';
import WAGONRImage2 from '../assets/images/WAGONR-2.jpeg.jpg';
import WAGONRImage3 from '../assets/images/WAGONR-3.jpeg.jpg';

import SUPERBImage1 from '../assets/images/SUPERB-1.jpeg.jpg';
import SUPERBImage2 from '../assets/images/SUPERB-2.jpeg.jpg';
import SUPERBImage3 from '../assets/images/SUPERB-3.jpeg.jpg';

import SWIFTTTTImage1 from '../assets/images/SWIFTTTT-1.jpeg.jpg';
import SWIFTTTTImage2 from '../assets/images/SWIFTTTT-2.jpeg.jpg';
import SWIFTTTTImage3 from '../assets/images/SWIFTTTT-3.jpeg.jpg';

import FORDDDDImage1 from '../assets/images/FORDDDD-1.jpeg.jpg';
import FORDDDDImage2 from '../assets/images/FORDDDD-2.jpeg.jpg';
import FORDDDDImage3 from '../assets/images/FORDDDD-3.jpeg.jpg';

import AUTOMATICImage1 from '../assets/images/AUTOMATIC-1.jpeg.jpg';
import AUTOMATICImage2 from '../assets/images/AUTOMATIC-2.jpeg.jpg';
import AUTOMATICImage3 from '../assets/images/AUTOMATIC-3.jpeg.jpg';

import SKODAAImage1 from '../assets/images/SKODAA-1.jpeg.jpg';
import SKODAAImage2 from '../assets/images/SKODAA-2.jpeg.jpg';
import SKODAAImage3 from '../assets/images/SKODAA-3.jpeg.jpg';

import MARUTHIIIIImage1 from '../assets/images/MARUTHIIII-1.jpeg.jpg';
import MARUTHIIIIImage2 from '../assets/images/MARUTHIIII-2.jpeg.jpg';
import MARUTHIIIIImage3 from '../assets/images/MARUTHIIII-3.jpeg.jpg';

import XINGGGGImage1 from '../assets/images/XINGGGG-1.jpeg.jpg';
import XINGGGGImage2 from '../assets/images/XINGGGG-2.jpeg.jpg';
import XINGGGGImage3 from '../assets/images/XINGGGG-3.jpeg.jpg';

import MagnaImage1 from '../assets/images/Magna-1.jpeg.jpg';
import MagnaImage2 from '../assets/images/Magna-2.jpeg.jpg';
import MagnaImage3 from '../assets/images/Magna-3.jpeg.jpg';

import AstaImage1 from '../assets/images/Asta-1.jpeg.jpg';
import AstaImage2 from '../assets/images/Asta-2.jpeg.jpg';
import AstaImage3 from '../assets/images/Asta-3.jpeg.jpg';

import FORTUNERrrrrImage1 from '../assets/images/FORTUNERrrrr-1.jpeg.jpg';
import FORTUNERrrrrImage2 from '../assets/images/FORTUNERrrrr-2.jpeg.jpg';
import FORTUNERrrrrImage3 from '../assets/images/FORTUNERrrrr-3.jpeg.jpg';

import TDIIIIIImage1 from '../assets/images/TDIIIII-1.jpeg.jpg';
import TDIIIIIImage2 from '../assets/images/TDIIIII-2.jpeg.jpg';
import TDIIIIIImage3 from '../assets/images/TDIIIII-3.jpeg.jpg';

import fortunerrrrrrImage1 from '../assets/images/fortunerrrrrr-1.jpeg.jpg';
import fortunerrrrrrImage2 from '../assets/images/fortunerrrrrr-2.jpeg.jpg';
import fortunerrrrrrImage3 from '../assets/images/fortunerrrrrr-3.jpeg.jpg';



const ownerInfo = {
    name: "Syed Shafiq",
    photo: "carman.jpg", // Replace with the actual photo URL
    contact: "+91-7676867700",
    location: "https://maps.app.goo.gl/BHYQrYg8uTxkj3udA",
};

const Cars = () => {
    // Cars data
    const cars = [
        {
            name: "Mahindra XUV 500 W10",
            year: "2016",
            price: "₹1,325,000",
            images: [xuv500Image1, xuv500Image2, xuv500Image3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: White",
                "KMs: 45,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "BMW 530D HL",
            year: "2018",
            price: "₹1,300,000",
            images: [bmwImage1, bmwImage2, bmwImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Black",
                "KMs: 35,000",
                "Fuel: Diesel",
                "Transmission: Automatic",
            ],
          },
          {
            name: "Honda city smt2010",
            year: "2010",
            price: "₹300,000.00",
            images: [HondaImage1, HondaImage2, HondaImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: White",
                "KMs: 45,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyoto Etios 2015",
            year: "2016",
            price: "₹5,85,000",
            images: [ToyotoImage1, ToyotoImage2, ToyotoImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: orange",
                "KMs: 75,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Ford Figo Zxi MT",
            year: "2014",
            price: "₹4,45,000",
            images: [FordImage1, FordImage2, FordImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: orange",
                "KMs: 43,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "JAGUAR XF ",
            year: "2016",
            price: "₹1,800,000.00",
            images: [JAGUARImage1, JAGUARImage2, JAGUARImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: White",
                "KMs: 45,000",
                "Fuel: Diesel",
                "Transmission: Automatic",
            ],
        },
        {
            name: "Hyndai Eon Era Plus MT",
            year: "2013",
            price: "₹3,010,000",
            images: [HyndaiImage1, HyndaiImage2, HyndaiImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Blue",
                "KMs: 49,000",
                "Fuel: Petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "Maruthi Suzuki Dzire VDI",
            year: "2009",
            price: "₹2,90,000",
            images: [MaruthiImage1, MaruthiImage2, MaruthiImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: red",
                "KMs: 85,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyotof Fortuner 4X2 MT",
            year: "2015",
            price: "₹19,75,000",
            images: [ToyotofImage1, ToyotofImage2, ToyotofImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: white",
                "KMs: 58,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Maruthiz Suzuki Dzire ",
            year: "2010",
            price: "₹3,25,000",
            images: [MaruthizImage1, MaruthizImage2, MaruthizImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Blue",
                "KMs: 70,000",
                "Fuel: Petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "MG Motor Hector plus De2.0 ",
            year: "2020",
            price: "₹19,50,000",
            images: [MGImage1, MGImage2, MGImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: silver",
                "KMs: 41,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Hyundaii i10 Magna",
            year: "2011",
            price: "₹5,85,000",
            images: [HyundaiiImage1, HyundaiiImage2, HyundaiiImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: orange",
                "KMs: 75,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Chevrolet cruze LTZ",
            year: "2012",
            price: "₹6,25,000",
            images: [ChevroletImage1, ChevroletImage2, ChevroletImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: White",
                "KMs: 58,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyato Fortuner AT",
            year: "2023",
            price: "₹41,50,000",
            images: [FortunerImage1, FortunerImage2,FortunerImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: White",
                "KMs: 28,000",
                "Fuel: Diesel",
                "Transmission: Automatic",
            ],
        },
        {
            name: "Hyundaii Elite 20 Asta ",
            year: "2018",
            price: "₹6,75,000",
            images: [EliteImage1, EliteImage2, EliteImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Silver",
                "KMs: 86,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Hyundaii Verna fluidice",
            year: "2013",
            price: "₹4,50,000",
            images: [ VernaiImage1, VernaiImage2,  VernaiImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Silver",
                "KMs: 82,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Hyundaii Getz GVS ",
            year: "2010",
            price: "₹2,45,000",
            images: [GetzImage1, GetzImage2, GetzImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Silver",
                "KMs: 97,000",
                "Fuel: Petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "Mahindra Marazzo M4 ",
            year: "2019",
            price: "₹4,00,000",
            images: [ MarazzoImage1, MarazzoImage2,  MarazzoImage3], // Multiple images
            details: [
                "Ownership: TWO",
                "Insurance: Comprehensive",
                "Color: Maroon",
                "KMs: 1,20,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Maruthi Suzuki Swift VXI",
            year: "2010",
            price: "₹3,25,000",
            images: [ suzukiImage1, suzukiImage2,  suzukiImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: White",
                "KMs: 85,000",
                "Fuel: Petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "Hyundaii I10 grand Asta ",
            year: "2017",
            price: "₹5,00,000",
            images: [ grandImage1, grandImage2,  grandImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Blue",
                "KMs: 82,000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyato Innova Crysts 2.8X",
            year: "2016",
            price: "₹17,75,000",
            images: [ InnovaImage1, InnovaImage2,  InnovaImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: White",
                "KMs:110637",
                "Fuel: Diesel",
                "Transmission: Automatic",
            ],
        },
        {
            name: "CHEVEROLET AVEO LT",
            year: "2010",
            price: "₹2,50,000",
            images: [ AVEOImage1, AVEOImage2,  AVEOImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Grey",
                "KMs: 87,000",
                "Fuel: Petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "Mahindra Scorpio",
            year: "2005",
            price: "₹1,95,000",
            images: [ ScorpioImage1, ScorpioImage2,  ScorpioImage3], // Multiple images
            details: [
                "Ownership: THIRD",
                "Insurance: Comprehensive",
                "Color: Silver",
                "KMs:132000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "FORD ECOSPORT TITANIUM",
            year: "2019",
            price: "₹8,50,000",
            images: [ FORDDImage1, FORDDImage2,  FORDDImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Brown",
                "KMs:63000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Maruthi Suzuki DZIRE",
            year: "2016",
            price: "₹2,90,000",
            images: [ DZIREImage1, DZIREImage2,DZIREImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Silver",
                "KMs:41000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "VW VENTO HIGHLINE",
            year: "2011",
            price: "₹4,25,000",
            images: [ VENTOOImage1, VENTOOImage2,  VENTOOImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: White",
                "KMs:78000",
                "Fuel: Petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyato Innova Crysts 2.4X",
            year: "2017",
            price: "₹19,85,000",
            images: [  CrystaImage1,  CrystaImage2,   CrystaImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: White",
                "KMs:86000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "VW POLO COMFORTLINE",
            year: "2016",
            price: "₹17,75,000",
            images: [ PoloImage1, PoloImage2,  PoloImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: White",
                "KMs:110637",
                "Fuel: Diesel",
                "Transmission: Automatic",
            ],
        },
        {
            name: "Toyato Innova Crysts GX",
            year: "2016",
            price: "₹15,00,000",
            images: [ InnovaaaImage1, InnovaaaImage2,  InnovaaaImage3], // Multiple images
            details: [
                "Ownership: TWO",
                "Insurance: Comprehensive",
                "Color: Purple",
                "KMs:78000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Mahindra XUV 500 W8",
            year: "2014",
            price: "₹8,00,000",
            images: [ XUVImage1, XUVImage2,  XUVImage3], // Multiple images
            details: [
                "Ownership: TWO",
                "Insurance: Comprehensive",
                "Color: Grey",
                "KMs:98000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Maruthi Suzuki SX4 VXI",
            year: "2009",
            price: "₹2,50,000",
            images: [ SX4Image1, SX4Image2,  SX4Image3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Grey",
                "KMs:42000",
                "Fuel: Petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyato Innova V ",
            year: "2016",
            price: "₹11,25,000",
            images: [ InnovaaImage1, InnovaaImage2,  InnovaaImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Silver",
                "KMs:140000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Mahindra Xylo E6 ",
            year: "2011",
            price: "₹4,55,000",
            images: [ XyloImage1, XyloImage2,  XyloImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: white",
                "KMs:95000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Maruthi Suzuki Swift VXI",
            year: "2014",
            price: "₹5,25,000",
            images: [ swifttImage1, swifttImage2,  swifttImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Silver",
                "KMs:300000",
                "Fuel: Petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "Renualt fluenece",
            year: "2011",
            price: "₹2,90,000",
            images: [ flueneceImage1, flueneceImage2,  flueneceImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Black",
                "KMs:126000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Maruthi Baleno Alfa Button Start ",
            year: "2016",
            price: "₹5,00,000",
            images: [ BalenoImage1, BalenoImage2, BalenoImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Grey",
                "KMs:140000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
       
        {
            name: "FORD Ecosport Titanium ",
            year: "2013",
            price: "₹4,80,000",
            images: [ EcosportImage1, EcosportImage2,  EcosportImage3], // Multiple images
            details: [
                "Ownership: TWO",
                "Insurance: Comprehensive",
                "Color: p.Green",
                "KMs:74000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Hyndai Snatro  ",
            year: "2008",
            price: "₹,85,000",
            images: [ santrooImage1,  santrooImage2, santrooImage3], // Multiple images
            details: [
                "Ownership: THird",
                "Insurance: Comprehensive",
                "Color: Silver",
                "KMs:58000",
                "Fuel: Petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyato crysta 2.8z ",
            year: "2013",
            price: "₹23,45,000",
            images: [  crystImage1, crystImage2,  crystImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: Grey",
                "KMs:56000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyato crysta 2.8 GX",
            year: "2019",
            price: "₹20,45,000",
            images: [GXXImage1, GXXImage2, GXXImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: brown",
                "KMs:95000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyato innova crysta",
            year: "2018",
            price: "₹21,75,000",
            images: [  innovasImage1,  innovasImage2,   innovasImage3], // Multiple images
            details: [
                "Ownership: single",
                "Insurance: Comprehensive",
                "Color:Bronze",
                "KMs:74000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyato Fortuner sigma ",
            year: "2019",
            price: "₹28,50,000",
            images: [ FortunerrImage1, FortunerrImage2,  FortunerrImage3], // Multiple images
            details: [
                "Ownership: Single",
                "Insurance: Comprehensive",
                "Color: white",
                "KMs:97000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Maruthi suzuki brezza ",
            year: "2013",
            price: "₹9,25,000",
            images: [ brezzaImage1, brezzaImage2, brezzaImage3], // Multiple images
            details: [
                "Ownership: single",
                "Insurance: Comprehensive",
                "Color: Red",
                "KMs:76000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Maxindra xuv500 w10 MT",
            year: "2013",
            price: "₹12,95,000",
            images: [MaxindraaImage1, MaxindraaImage2,  MaxindraaImage3], // Multiple images
            
            details: [
                "Ownership: single",
                "Insurance: Comprehensive",
                "Color: white",
                "KMs:45000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Toyato Fortunur",
            year: "2014",
            price: "₹17,90,000",
            images: [FortunerrImage1, FortunerrImage2,  FortunerrImage3], // Multiple images
            
            details: [
                "Ownership: single",
                "Insurance: Comprehensive",
                "Color: white",
                "KMs:84000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "BMW 320i",
            year: "2007",
            price: "₹5,75,000",
            images: [BMWwImage1, BMWwImage2, BMWwImage3], // Multiple images
            
            details: [
                "Ownership: single",
                "Insurance: Comprehensive",
                "Color: white",
                "KMs:45000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
        {
            name: "Nissan micra",
            year: "2011",
            price: "₹3,20,000",
            images: [micraImage1, micraImage2,  micraImage3], // Multiple images
            
            details: [
                "Ownership: single",
                "Insurance: Comprehensive",
                "Color: white",
                "KMs:30000",
                "Fuel: Petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "Kia sonet",
            year: "2022",
            price: "₹13,25,000",
            images: [sonetImage1, sonetImage2,  sonetImage3], // Multiple images
            
            details: [
                "Ownership: Two",
                "Insurance: Comprehensive",
                "Color: white",
                "KMs:21000",
                "Fuel: Diesel",
                "Transmission: Manual",
            ],
        },
      
        {
            name: "MARUTI WAGONR VXI ",
            year: "2010",
            price: "₹2,75,000",
            images: [WAGONRImage1, WAGONRImage2,  WAGONRImage3], // Multiple images
            
            details: [
                "Ownership: Two",
                "Insurance: Laps",
                "Color: silver",
                "KMs:44494",
                "Fuel: petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "SKODA SUPERB 2.0 CR TDI AT ",
            year: "2013",
            price: "₹7,75,000",
            images: [SUPERBImage1, SUPERBImage2,  SUPERBImage3], // Multiple images
            
            details: [
                "Ownership: Two",
                "Insurance: Laps",
                "Color: silver",
                "KMs:103489",
                "Fuel: DISEL",
                "Transmission: Manual",
            ],
        },
        {
            name: "MARUTI SWIFT VDI MT ",
            year: "2014",
            price: "₹5,75,000",
            images: [SWIFTTTTImage1, SWIFTTTTImage2,  SWIFTTTTImage3], // Multiple images
            
            details: [
                "Ownership: THIRD",
                "Insurance: Laps",
                "Color: WHITE",
                "KMs:96467",
                "Fuel: DISEL",
                "Transmission: Manual",
            ],
        },
        {
            name: "FORD FIGO ZXI DISEL ",
            year: "2013",
            price: "₹2,65,000",
            images: [FORDDDDImage1, FORDDDDImage2,  FORDDDDImage3], // Multiple images
            
            details: [
                "Ownership: Two",
                "Insurance: Laps",
                "Color: Grey",
                "KMs:56999",
                "Fuel: DISEL",
                "Transmission: Manual",
            ],
        },
        {
            name: "MARUTI SWIFT VXI AUTOMATIC ",
            year: "2019",
            price: "₹6,65,000",
            images: [AUTOMATICImage1, AUTOMATICImage2,  AUTOMATICImage3], // Multiple images
            
            details: [
                "Ownership: Two",
                "Insurance: Laps",
                "Color: RED",
                "KMs:44456",
                "Fuel: petrol",
                "Transmission: Automatic",
            ],
        },
        {
            name: "SKODA RAPID ELEGANCE DISEL MT ",
            year: "2012",
            price: "₹5,40,000",
            images: [SKODAAImage1, SKODAAImage2,  SKODAAImage3], // Multiple images
            
            details: [
                "Ownership: Two",
                "Insurance: Laps",
                "Color: silver",
                "KMs:80673",
                "Fuel: petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "MARUTHI SWIFT VDI MT ",
            year: "2009",
            price: "₹2,90,000",
            images: [MARUTHIIIIImage1, MARUTHIIIIImage2,  MARUTHIIIIImage3], // Multiple images
            
            details: [
                "Ownership: THIRD",
                "Insurance: Laps",
                "Color:BLUE",
                "KMs:80673",
                "Fuel: DISEL",
                "Transmission: Manual",
            ],
        },
        {
            name: "HYNDAI SANTRO XING GLS ",
            year: "2010",
            price: "₹2,55,000",
            images: [XINGGGGImage1, XINGGGGImage2,  XINGGGGImage3], // Multiple images
            
            details: [
                "Ownership: Two",
                "Insurance: Laps",
                "Color:GREY",
                "KMs:50638",
                "Fuel: petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "HYNDAI I20 Magna",
            year: "2010",
            price: "₹2,75,000",
            images: [MagnaImage1,MagnaImage2,MagnaImage3], // Multiple images
            
            details: [
                "Ownership: Two",
                "Insurance: Laps",
                "Color:GREY",
                "KMs:88000",
                "Fuel: petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "HYNDAI I20 Asta  ",
            year: "2012",
            price: "₹3,95,000",
            images: [AstaImage1, AstaImage2,  AstaImage3], // Multiple images
            
            details: [
                "Ownership: Single",
                "Insurance: Laps",
                "Color:GREY",
                "KMs:78000",
                "Fuel: petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "fORTUNER",
            year: "2018",
            price: "₹22,55,000",
            images: [FORTUNERrrrrImage1,FORTUNERrrrrImage2, FORTUNERrrrrImage3], // Multiple images
            
            details: [
                "Ownership:Single",
                "Insurance: Laps",
                "Color:GREY",
                "KMs:98000",
                "Fuel: petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "Polo  TDI ",
            year: "2010",
            price: "₹3,55,000",
            images: [TDIIIIIImage1, TDIIIIIImage2,  TDIIIIIImage3], // Multiple images
            
            details: [
                "Ownership: Two",
                "Insurance: Laps",
                "Color:SILVER",
                "KMs:50638",
                "Fuel: petrol",
                "Transmission: Manual",
            ],
        },
        {
            name: "fortuner ",
            year: "2015",
            price: "₹31,00,000",
            images: [fortunerrrrrrImage1, fortunerrrrrrImage2,  fortunerrrrrrImage3], // Multiple images
            
            details: [
                "Ownership: Two",
                "Insurance: Laps",
                "Color:white",
                "KMs:98000",
                "Fuel: petrol",
                "Transmission: Manual",
            ],
        },
    ];

    // Slider settings
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    return (
        <div className="cars-section">
            <h1>Available Cars</h1>
            <div className="cars-grid">
                {cars.map((car, index) => (
                    <div className="car-item" key={index}>
                        <Slider {...sliderSettings}>
                            {car.images.map((image, idx) => (
                                <img key={idx} src={image} alt={`${car.name} ${idx + 1}`} />
                            ))}
                        </Slider>
                        <h3>{car.name}</h3>
                        <p>Year: {car.year}</p>
                        <p className="price">{car.price}</p>
                        <ul>
                            {car.details.map((detail, idx) => (
                                <li key={idx}>{detail}</li>
                            ))}
                        </ul>
                        <a href="/profile" className="btn">Details</a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Cars;
